export default __webpack_public_path__ + "static/media/duster-colour-1.5e4ad0a0.jpg";